import React, { useState } from "react";
import ImageTag from "../../ImageTag/Index";

const SubMenu = ({ submenus }) => {
  const [hoverIndex, setHoverIndex] = useState(null);

  return (
    <div className="dropdown-content">
      <div className="submenu">
        <div className="submenu_Child">
          {submenus.map((submenu, index) => {
            const url = submenu.ext_url
              ? submenu.ext_url
              : submenu.slug;

            return (
              <div
                className="submenu_row col-12 float-start"
                key={index}
                onMouseEnter={() => setHoverIndex(index)}
                onMouseLeave={() => setHoverIndex(null)}
              >
                <div className="submenucontent subMenucontent">
                  {url ? (
                    <a
                      href={url}
                      target={submenu.ext_url ? "_blank" : "_self"}
                      rel="noopener noreferrer"
                    >
                      <p>{submenu.text}</p>
                    </a>
                  ) : (
                    <p>{submenu.text}</p>
                  )}
                </div>

                <div
                  className="submenuicons subMenucontIcon"
                  style={{
                    display:
                      index === 0 || hoverIndex === index ? "block" : "none",
                  }}
                >
                  <ImageTag ImagePath={submenu.icon} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SubMenu;